import styled from 'styled-components';
import { media, colors, fonts } from 'settings/style';

export const PageShell = styled.div`
  background: #ffffff;
  padding-bottom: 2rem;
`;

export const PageHeader = styled.header`
  padding: 2.25rem 0 1.5rem;
  max-width: 100%;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;

  ${media.md`
    padding: 1.5rem 0 1.25rem;
  `}
`;

export const PageTitle = styled.h1`
  margin: 0 0 8px;
  font-family: ${fonts.tertiary};
  font-size: 2.25rem;
  color: ${colors.grey900};

  ${media.md`
    font-size: 1.75rem;
  `}
`;

export const PostListWrapper = styled.div`
  padding: 0 0 1.5rem;
  flex: 1;
  min-width: 0;
  width: 100%;
  background: #ffffff;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;

  ${media.md`
    padding: 0 0 1rem;
  `}
`;
